import { render, staticRenderFns } from "./pro-chiose-address-book.vue?vue&type=template&id=8edba75c&scoped=true";
import script from "./pro-chiose-address-book.vue?vue&type=script&lang=jsx";
export * from "./pro-chiose-address-book.vue?vue&type=script&lang=jsx";
import style0 from "./pro-chiose-address-book.vue?vue&type=style&index=0&id=8edba75c&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "8edba75c", null);
export default component.exports;